
import Layout from "../components/layout/Layout";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import Box from "@mui/material/Box";
import { dashboards } from "../dashboardRow";
import "../styles/Subscription.css";

const Subscription = () => {
  return (
    <>
      <Layout>
        <div className="container m-4">
          <div className="row">
            {dashboards?.map((d, index) => {
              return (
                <div className="col-4" key={index}>
                  <FormGroup className="m-3">
                    <h6>{d.name}</h6>
                    <Box
                      sx={{
                        maxHeight: "130px",
                        overflowY: "auto",
                        "&::-webkit-scrollbar": {
                          width: "6px",
                        },
                        "&::-webkit-scrollbar-track": {
                          backgroundColor: "#f1f1f1",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          backgroundColor: "gray",
                          borderRadius: "4px",
                        },
                      }}
                    >
                      {d.reports.map((r, i) => {
                        return (
                          <FormControlLabel
                            className="Subscription"
                            style={{ marginLeft: "1rem", display: "block" }}
                            key={i}
                            control={
                              <Checkbox
                                name="checkedBox"
                                color="primary"
                                className="Subscription"
                              />
                            }
                            label={r.name}
                            labelProps={{ className: "Subscription" }}
                          />
                        );
                      })}
                    </Box>
                  </FormGroup>
                </div>
              );
            })}
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Subscription;
